module.exports = __webpack_public_path__ + "static/media/loadingConfirmationPayment.59385d4b.gif";